<template>
  <q-form ref="formRef" no-error-focus class="flex flex-col">
    <div
      class="flex-1 size-full grid grid-cols-2 gap-x-16 gap-y-24 p-24 overflow-y-auto min-w-0"
    >
      <OInput
        v-model="pergunta.pergunta"
        size="md"
        type="text"
        :label="t('title')"
        :rules="[(v) => !!v?.length]"
        class="label-transparent col-span-2 !text-[red]"
      />

      <OInput
        v-model="pergunta.descricao"
        size="lg"
        type="textarea"
        stack-label
        :label="t('description')"
        :placeholder="t('writeHere')"
        :rules="[(v) => !!v?.length]"
        class="col-span-2 label-transparent showPlaceholderOnStack"
      />

      <OInput
        v-model="pergunta.ordem"
        size="md"
        type="number"
        :label="t('order')"
        class="col-span-2"
        :rules="[(v) => v >= 0]"
      />

      <OInput
        v-model="pergunta.pontos"
        size="md"
        type="text"
        :label="t('points')"
        :rules="[(v) => !!v?.toString().length]"
      />
      <div class="size-full flex flex-col gap-2">
        <OLabel :text="t('needsEvidence')" />
        <div
          class="h-full flex items-center gap-8 flex-nowrap px-14 rounded-md border border-neutral-100/10"
        >
          <q-toggle
            v-model="pergunta.necessita_evidencia"
            size="md"
            :label="null"
          />
          <span class="text-paragraph-4 text-neutral-70">
            {{ t('disableEvidenceMessage') }}
          </span>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import OInput from 'components/Input/OInput.vue'
import OLabel from 'components/Label/OLabel.vue'

const { t } = useI18n()

const props = defineProps({
  initialPergunta: { type: Object, required: true },
})

const pergunta = ref({ ...props.initialPergunta })
const formRef = ref(null)

watch(
  pergunta,
  (newVal) => {
    emit('change:pergunta', newVal)
  },
  { deep: true }
)

const emit = defineEmits(['change:pergunta'])

const validate = () => formRef.value?.validate()

defineExpose({ validate })
</script>
